(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('BatteryTestSearch', BatteryTestSearch);

    BatteryTestSearch.$inject = ['$resource'];

    function BatteryTestSearch($resource) {
        var resourceUrl =  'api/_search/battery-tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
